'use client';

import { FloatingActionButton } from '@crabs-ai/ds-react/stories/primitives/buttons/floating-action-button/index';
import { useTheme } from 'next-themes';
import dynamic from 'next/dynamic';

import DarkModeFill from '@/shared/ui/generated-web-icons/DarkModeFill';
import WbSunnyFill from '@/shared/ui/generated-web-icons/WbSunnyFill';

function DarkModeToggleClient() {
  const { theme, setTheme } = useTheme();

  const handleClick = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <FloatingActionButton
      extended
      leadingNode={theme === 'dark' ? <DarkModeFill /> : <WbSunnyFill />}
      onClick={handleClick}
    />
  );
}

export const DarkModeToggle = dynamic(
  () => Promise.resolve(DarkModeToggleClient),
  { ssr: false },
);
